module.exports = __webpack_public_path__ + "static/media/extroversion-spectrum.e2908ecb.png";